/// <reference path="../../lib/app.d.ts" />

import {JoinedRoomData, ModeSetupUpdateData} from "./sx-server";
import {Collection} from "../lib/event-interface";

export class RoomList
{
	roomList : Array<JoinedRoomData> = [];
	ready : boolean = false;
	evt : Collection;

	constructor()
	{
		this.evt = new Collection("roomList");
	}

	public update(room : JoinedRoomData)
	{
		// if (room.roomMode === "offline")
		// {
		// 	// Remove offline rooms
		// 	for (let i = this.roomList.length - 1; i >= 0; i--)
		// 	{
		// 		if (this.roomList[i].roomid === room.roomid) {
		// 			this.roomList.splice(i, 1);
		// 		}
		// 	}
		// }
		// else
		// {
			// Update or add new room...

			let foundRoom : number = null;

			for (let i = this.roomList.length - 1; i >= 0; i--)
			{
				if (this.roomList[i].roomid.toString() === room.roomid.toString()) {
					foundRoom = i;
					break;
				}
			}

			if (foundRoom !== null) this.roomList[foundRoom] = room;
			else this.roomList.push(room);
		// }

		this.evt.trigger("update", room);
	}

	initialize(rooms : Array<JoinedRoomData>)
	{
		this.ready = true;
		this.roomList = rooms;
		this.evt.trigger("ready", rooms);
	}

	isReady()
	{
		return this.ready;
	}

	/**
	 * Returns a random free room (if there is any)
	 */
	public getRandomFree(except : string[] = [], includeBoys : boolean = true) : JoinedRoomData
	{
		if (!except) except = [];

		const filtered = this.roomList.filter((room) =>
		{
			let isBoy = room.publicData && room.publicData.primaryCat && ["Boy", "BoyCouple"].indexOf(room.publicData.primaryCat) !== -1;
			let isFree = room.roomMode === "free";
			let freeAllowed = ("allowedModes" in room) && room.allowedModes && room.allowedModes.indexOf("free") !== -1;
			let sameAs = except && except.indexOf(room.roomid) > -1;

			return isFree && freeAllowed && !sameAs && (includeBoys || !isBoy);
		});

		if (filtered.length) {
			const rand = Math.floor(Math.random() * filtered.length);
			return filtered[rand];
		} else {
			return null;
		}
	}

	/**
	 * Returns a random room (if there is any)
	 */
	public getRandomOnline(except : string[] = [], includeBoys : boolean = true) : JoinedRoomData
	{
		if (!except) except = [];

		const filtered = this.roomList.filter((room) =>
		{
			let isBoy = room.publicData && room.publicData.primaryCat && ["Boy", "BoyCouple"].indexOf(room.publicData.primaryCat) !== -1;
			let sameAs = except && except.indexOf(room.roomid) > -1;
			let isOnline = ["free", "vip", "group", "private", "exclusive"].indexOf(room.roomMode) !== -1;
			return !sameAs && isOnline && (includeBoys || !isBoy);
		});

		if (filtered.length) {
			const rand = Math.floor(Math.random() * filtered.length);
			return filtered[rand];
		} else {
			return null;
		}
	}

	public getSampler(): JoinedRoomData[] {
		return this.roomList;
	}

	public getByID(id : string) : JoinedRoomData
	{
		for(let i=0; i<this.roomList.length; i++)
		{
			if (this.roomList[i].roomid == id) {
				return this.roomList[i]
			}
		}

		return null;
	}

	updateModeSetup(data: ModeSetupUpdateData)
	{
		let currentRoom = null;

		for (let room of this.roomList) {
			if (room.roomid == data.roomid) {
				currentRoom = room;
				break;
			}
		}

		if ("allowedModes" in data) currentRoom.allowedModes = data.allowedModes;
		if ("pricing" in data && data.pricing) {
			for (let key of Object.keys(data.pricing)) {
				currentRoom.pricing[key] = data.pricing[key];
			}
		}
	}
}
